import React from 'react'
import BaseDialog from '../../../components/dialog'
import iconTimes from '../../../assets/images/icon-times.svg'
import ButtonBase from '../../../components/partials/button'
import { defaultCustomStyles } from '../../../constants/customStyles'

type Props = {
  modalIsOpen?: boolean
  statusValue?: boolean | null
  handleCloseDialog?: (val: boolean) => void
  handleChangeAutoSendWebhook?: () => void
}

const ChangeAutoSendWebhookDialog: React.FunctionComponent<Props> = ({
  modalIsOpen,
  statusValue,
  handleCloseDialog = () => null,
  handleChangeAutoSendWebhook = () => null,
}) => {
  return (
    <BaseDialog modalIsOpen={modalIsOpen} customStyles={defaultCustomStyles}>
      <React.Fragment>
        <div className="flex justify-between">
          <div className="absolute right-4 top-4">
            <img
              src={iconTimes}
              alt=""
              className="cursor-pointer"
              onClick={() => handleCloseDialog(false)}
            />
          </div>
        </div>
        <div>
          <p className="text-headline4 text-center text-neutral-1">
            {statusValue ? 'Stop auto sending webhook' : 'Enable auto sending webhook'}
          </p>
          <p className="text-body1 text-neutral-3 text-center py-6">
            {statusValue
              ? 'Do you really want to stop sending webhook?'
              : 'Do you really want to enable auto sending webhook?'}
          </p>
          <div className="flex justify-between gap-3">
            <ButtonBase
              type="button"
              className="w-[180px] h-[52px] border-0 bg-primary-1 text-hairline1 min-w-min text-center text-neutral-8"
              onClick={() => handleCloseDialog(false)}
            >
              Cancel
            </ButtonBase>
            <ButtonBase
              type="reset"
              className="w-[180px] h-[52px] text-hairline1 bg-neutral-8 border-2 border-primary-1 text-primary-1 hover:bg-primary-shade4"
              onClick={handleChangeAutoSendWebhook}
            >
              Confirm
            </ButtonBase>
          </div>
        </div>
      </React.Fragment>
    </BaseDialog>
  )
}

export default ChangeAutoSendWebhookDialog
